import { render } from "./NewOrderModal.vue?vue&type=template&id=bffd5d96&scoped=true"
import script from "./NewOrderModal.vue?vue&type=script&lang=js"
export * from "./NewOrderModal.vue?vue&type=script&lang=js"

import "./NewOrderModal.vue?vue&type=style&index=0&id=bffd5d96&scoped=true&lang=css"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bffd5d96"]])

export default __exports__